import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: ${theme.spacing['2xl']};
  min-height: 100vh;
  padding: ${theme.spacing.xl};
  margin: 0 auto;
`;
export const Line = styled.hr `
  margin-left: inherit;
  width: ${pxToRem(125)};
  border-color: ${theme.semantic.border.default};
  margin-bottom: ${theme.spacing.lg};
`;
export const Image = styled.img `
  display: block;
  max-width: 100%;
`;
